import React from 'react';
import { connect } from 'react-redux';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import RecoverPassword from '../Components/Login/RecoverPassword';

const RecoverPasswordPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <RecoverPassword />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(RecoverPasswordPage);
